import RegularUtil from '../../utils/RegularUtil';
import FormItemDecimalResolver from '../resolver/FormItemDecimalResolver';

export default class FormItemDecimalDisplay
{
	
	static THOUSANDSEPERATOR = ",";
	
	static getDisplayText(value,showZero,showDecimals,thousandSeperator,parms={})
	{
		if(value==null || (value != 0&&value == ""))
		{
			return "";
		}
		else
		{

			return FormItemDecimalDisplay.formatLabel(value,showZero,showDecimals,thousandSeperator,parms);	
		}
		
	}
	
	static formatLabel(value,showZero,showDecimals,thousandSeperator,parms={})
	{
		
		var integerPart;
		var decimalPart;
		value = value+"";
		if((Number(value)+"") == "0" && 
			!showZero
			)
			return "";
			
		if(value.indexOf(".") != -1)
		{
			integerPart = value.substring(0,value.indexOf("."));
			decimalPart = value.substring(value.indexOf(".")+1);
		}
		else
		{
			integerPart = value;
			decimalPart = "";
		}
		
		var formattedIntegerPart = FormItemDecimalDisplay.formatInteger(integerPart,thousandSeperator);
		var formattedDecimalPart = FormItemDecimalDisplay.formatDecimalPart(decimalPart,showDecimals);

		var suffix = "";var prefix = "";
		if(parms.type == "percent")
		{
			suffix = "%";
		}
		else if(parms.type == "prefix")
		{
			prefix = parms.prefix;
		}

		if(typeof(formattedDecimalPart) == "boolean" && formattedDecimalPart == false)
		{
			var halfupStr = FormItemDecimalResolver.getHalfUp(value,value,showDecimals);
			if(thousandSeperator == true && halfupStr)
			{
				try
				{
					halfupStr = parseFloat(halfupStr).toLocaleString("en-US"); 
					if(showDecimals>0 && halfupStr.indexOf(".")==-1)
					{
						var tnum = showDecimals;halfupStr+=".";
						while(tnum>0)
						{
							halfupStr+="0";
							tnum--;
						}
					}
				}
				catch(e){}
			}
			return prefix + halfupStr + suffix;
		}

		if(formattedDecimalPart == "")
		{
			var firstDecimalStr = decimalPart.charAt(0);
			var firstDecimalNum = Number(firstDecimalStr);
			if(firstDecimalNum >= 5)
			{
				var num;
				if(formattedIntegerPart.charAt(0) == "-")
				{
					num = Number(formattedIntegerPart.substr(1));
					num ++;
					return prefix + "-" + num + suffix;
				}
				else
				{
					num = Number(formattedIntegerPart);
					num ++;
					return prefix+num+suffix;
				}
			}
			else
			{
				return prefix+formattedIntegerPart+suffix;
			}
				
		}
		else
		{
			if(formattedIntegerPart == "")formattedIntegerPart = "0";
			return prefix + formattedIntegerPart + "." + formattedDecimalPart + suffix; 
		}
			
	}
	
	
	static filtZero(input)
	{
		var i = 0;
		var result;
		var flag = Number(input) < 0 ? true:false;
		if(flag)
		{
			while(input.charAt(i) == "-" || input.charAt(i) == "0")
			{
				i++;
			}
		}
		else
		{
			while(input.charAt(i) == "0")
			{
				i++;
			}
		}
		
		result = input.substr(i);
		
		if(flag)
			result = "-" + result;
		
		return result.split("");
	}
	
	static formatDecimalPart(value,showDecimals)
	{
		var decimalNum = showDecimals;
		if(decimalNum == 0)
			return "";
		
		if(decimalNum < value.length)
		{
			var end = value.charAt(decimalNum);
			var penult = value.charAt(decimalNum - 1);
			if(Number(end) < 5)
			{
				value = value.substr(0,decimalNum);	
			}
			else
			{
				//389.497
				let penultNum = Number(penult) + 1;
				if(penultNum>9)
				{
					return false;
					//value = value.substr(0,decimalNum-1) + Number(penult) + 1;
					//value = FormItemDecimalResolver.getHalfUp(value,value,showDecimals);
				}
				else
				{
					value = value.substr(0,decimalNum-1) + penultNum;
				}
				
			}
		}
		else
		{
			while(value.length < decimalNum)
			{
				value += "0";
			}
		}
		
		return value;
	}
	
	static formatInteger(value,thousandSeperator)
	{
		var chars = [];
		
		if(value == "")
			return "";
	
		if(!thousandSeperator)
		{
			return value;
		}
		var negative = Number(value)<0;
		if(negative)
		{
			if(value.length < 5)
			{
				return value;
			}
			else
			{
				chars = FormItemDecimalDisplay.filtZero(value);
			}
		}
		else
		{	
			if(value.length < 4 )
			{
				return value;
			}
			else
			{
				chars = FormItemDecimalDisplay.filtZero(value);
			}
		}
		
		if(chars == null)
		{
			chars = value.split("");
		}
		
		return RegularUtil.setThounsandSeperator(chars,FormItemDecimalDisplay.THOUSANDSEPERATOR);
		
	}
}



// WEBPACK FOOTER //
// ./src/formItem/display/FormItemDecimalDisplay.js